export const formatCurrency = (
  value: Parameters<Intl.NumberFormat['format']>[0],
  currency: string = 'CZK',
  options: Intl.NumberFormatOptions = {},
) => {
  if (typeof value === 'undefined') return value

  const formatter = new Intl.NumberFormat('cs-CZ', {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0,
    ...options,
  })

  return formatter.format(value)
}
